export enum UseType {
	TO_ASSEMBLE = 'TO_ASSEMBLE',
	TO_DRILL = 'TO_DRILL',
	TO_CONTROL = 'TO_CONTROL',
	TO_OPTIMISE = 'TO_OPTIMISE',
	TO_REMOVE_MATERIAL = 'TO_REMOVE_MATERIAL',
}

export enum ItemType {
	ACCESSORY = 'accessory',
	PRODUCT = 'product',
	SERVICE = 'service',
	SPARE_PART = 'sparepart',
}

export enum ItemStatusLabel {
	ACTIVE = 'active',
	OUT_OF_PRODUCTION = 'inactive_out_of_production',
	NOT_SOLD = 'inactive_not_sold',
}

export enum ItemStatusCode {
	E1 = 'E1',
	E2 = 'E2',
	E3 = 'E3',
	H1 = 'H1',
	H2 = 'H2',
	H4 = 'H4',
	O9 = 'O9',
	QB = 'QB',
	QW = 'QW',
	VE = 'VE',
	VH = 'VH',
	Z1 = 'Z1',
	Z2 = 'Z2',
	Z3 = 'Z3',
	Z4 = 'Z4',
	Z5 = 'Z5',
	Z6 = 'Z6',
	Z8 = 'Z8',
	Z9 = 'Z9',
	ZP = 'ZP',
	ZT = 'ZT',
	ZY = 'ZY',
	ZZ = 'ZZ',
}
